export interface LanguageDropdownList{
    code: any
    text: any
}

export const LanguageList: LanguageDropdownList[] = [
    {"code": "en", "text": "English"},
    {"code": "fr", "text": "French"}
]